import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@auth/auth-guard.service';
import { LoginComponent } from '@auth/login/login.component';
import { WebSynapseComponent } from '@main/websynapse/web-synapse.component';
import { WelcomeScreenComponent } from '@main/welcome-screen/welcome-screen.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: WebSynapseComponent,
    children: [
      { path: 'welcome', component: WelcomeScreenComponent },
      {
        path: 'inventory',
        loadChildren: () => import('@inventory/inventory.module').then((m) => m.InventoryModule),
      },
      {
        path: 'orders',
        loadChildren: () => import('@orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('@reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('@admin/admin.module').then((m) => m.AdminModule),
      },
      { path: '**', redirectTo: 'welcome' },
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
